import { MdAccessTime } from '@react-icons/all-files/md/MdAccessTime'
import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { isTerminated } from '~/constants/task-status'
import { useTaskLastUpdated, useTaskStatus } from '~/hooks'
import { useIsS3Task } from '~/hooks/task/useS3Task'

interface CampaignTaskDurationProps {
  createdTime: number
}

export function CampaignTaskDuration({ createdTime }: CampaignTaskDurationProps) {
  const taskStatus = useTaskStatus()
  const taskLastUpdatedAt = useTaskLastUpdated()
  const [latestTime, setLatestTime] = useState<number>(createdTime)
  const isS3Task = useIsS3Task()

  useEffect(() => {
    const timer = setInterval(() => {
      setLatestTime(Date.now())
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [])

  const lastUpdated = isTerminated(taskStatus, isS3Task) ? taskLastUpdatedAt : latestTime
  const duration = dayjs.duration(dayjs(lastUpdated).diff(dayjs(createdTime)))

  const hours = duration.hours()
  const minutes = duration.minutes()
  const seconds = Math.max(duration.seconds(), 0)
  const durationInStr =
    (hours > 0 ? `${hours}h ` : '') + (minutes > 0 ? `${minutes}min ` : '') + `${seconds}s`

  return (
    <div className='duration flex items-center'>
      <MdAccessTime className='mr-1' size={14} />
      {durationInStr}
    </div>
  )
}
